import { Component, inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Chargepoint } from '../../../api/chargepoints-api.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ChargepointConfigurationOcppComponent } from '../chargepoint-configuration-ocpp/chargepoint-configuration-ocpp.component';

@Component({
  selector: 'app-chargepoint-configuration-dialog',
  templateUrl: './chargepoint-configuration-dialog.component.html',
  styleUrls: ['./chargepoint-configuration-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ChargepointConfigurationOcppComponent
  ]
})
export class ChargepointConfigurationDialogComponent {
  public chargepoint!: Chargepoint;

  dialogRef = inject(MatDialogRef<ChargepointConfigurationDialogComponent>);
  data = inject(MAT_DIALOG_DATA);

  constructor() {
    this.chargepoint = this.data.chargepoint;
  }

  public close() {
    this.dialogRef.close();
  }
}
